<template>
	<div class="customer-area-page">
		<b-container>
			<h1>Berechtigungsprüfung</h1>
			<template v-if="confirmAgain">
				<p class="font-weight-extra-bold color-primary">Du hast ausgewählt:</p>
				<p>{{ type.label }}</p>
				<div class="mt-5 d-flex align-items-center justify-content-end">
					<a v-if="!confirming" href="#" @click.prevent="abort">Abbrechen</a>
					<Button
						class="ml-4"
						text="Bestätigen"
						icon="checkmark"
						:disabled="!dataValid || confirming"
						:loading="confirming"
						@click="confirm"
					/>
				</div>
			</template>
			<template v-else>
				<p class="font-weight-extra-bold color-primary">
					Höchster Datenschutz, Anonymität und Vertraulichkeit ist für alle Nutzer wichtig.
					Daher wird regelmäßig geprüft, ob alle User berechtigt sind, Suchen nach Bewerbern
					durchzuführen.
				</p>
				<p v-if="companyName">Bist du befugt, für <b class="color-red">{{ companyName }}</b> zu suchen?</p>
				<div class="mb-3">
					<TreeSelect
						v-model="type"
						:characteristics="meta.customerSearchPermission"
					/>
				</div>
				<p>
					<b>Hinweis:</b> Falsche Angaben werden ohne Ausnahme direkt an die zuständigen Behörden
					zur Anzeige gebracht, führen zu Pönalzahlungen und zur Sperre des Accounts.<br/>
					Die Eingaben werden gespeichert und an eine unabhängige Stelle weitergeleitet.
				</p>
				<div class="mt-5 d-flex align-items-center justify-content-end">
					<a v-if="!loggingOut" href="#" @click.prevent="logout">Abbrechen (Abmelden)</a>
					<Button
						class="ml-4"
						text="Speichern"
						icon="checkmark"
						:disabled="!dataValid || loggingOut"
						:loading="loggingOut"
						@click="confirm"
					/>
				</div>
			</template>
		</b-container>
	</div>
</template>

<script>
import Button from "@/vue/common/Button";
import {isDefined} from "@/helper/Value";
import Logout from "@/api/auth/Logout";
import Legitimate from "@/api/customer/legitimation/Legitimate";
import {SEARCH_PERMISSION} from "@/helper/customer/legitimation/Type";
import TreeSelect from "@/vue/characteristic/TreeSelect";
import {mapState} from "vuex";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";

export default {

	components: {
		TreeSelect,
		Button,
	},

	props: {
		companyName: {
			type: String,
			required: true,
		},
	},

	data ()
	{
		return {
			type: undefined,
			confirming: false,
			loggingOut: false,
			confirmAgain: false,
		};
	},

	computed: {
		...mapState('meta', [
			'meta'
		]),
		typeValid ()
		{
			return isDefined(this.type);
		},
		dataValid ()
		{
			return this.typeValid;
		},
	},

	methods: {
		abort ()
		{
			this.type = undefined;
			this.confirmAgain = false;
		},
		async confirm ()
		{
			if (!this.confirmAgain)
			{
				this.confirmAgain = true;

				return;
			}

			this.confirming = true;

			try
			{
				await new Legitimate()
					.setType(SEARCH_PERMISSION)
					.setValue(this.type.id)
					.setRemoveMustReconfirmSearchPermissionOnSuccess(true)
					.call();

				if (this.type.naturalId === 'help')
				{
					// TODO something to do?
				}

				this.redirect();
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));

				this.confirming = false;
			}
		},
		async logout ()
		{
			this.loggingOut = true;

			await new Logout()
				.call();

			this.redirect();
		},
		redirect ()
		{
			location.href = '/auth/login';
		}
	},
}
</script>
